import { render, staticRenderFns } from "./crudPriceListSuppliers.vue?vue&type=template&id=affe69d8&scoped=true&"
import script from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
export * from "./crudPriceListSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./crudPriceListSuppliers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudPriceListSuppliers.vue?vue&type=style&index=1&id=affe69d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affe69d8",
  null
  
)

export default component.exports